import { Identifiable } from '@approvalmax/types';
import { DropdownEditor, FocusImplementer } from '@approvalmax/ui';
import { PlainDataProvider } from 'modules/data-providers';
import { memo } from 'react';

import { QbooksLineItemDropdownCellProps } from './QbooksLineItemDropdownCell.types';

export const QbooksLineItemDropdownCell = memo(
    <Value extends Identifiable>(props: QbooksLineItemDropdownCellProps<Value>) => {
        const { qa, invalid, placeholder, items, value, onChange, className, listItem } = props;

        return (
            <FocusImplementer>
                {({ registerFocusable }) => (
                    <>
                        <PlainDataProvider items={items}>
                            <DropdownEditor
                                className={className}
                                qa={qa}
                                ref={registerFocusable}
                                invalid={invalid}
                                value={value || null}
                                onChange={onChange}
                                placeholder={placeholder}
                                theme='transparent'
                                listItem={listItem}
                            />
                        </PlainDataProvider>
                    </>
                )}
            </FocusImplementer>
        );
    }
);

QbooksLineItemDropdownCell.displayName = 'QbooksLineItemDropdownCell';
